import { BaseModel } from "./base.model";

export class Perspective extends BaseModel {

    angle!: number;
    position!: number;
    svgImageUrl!: string;
    baseImageUrl!: string;

}